import 'twin.macro';
import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import Input from '@teetsh/app/src/components/Form/InputGroup/formWrapper';
import { UserProfile } from '@teetsh/app/src/types/user';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import Button from '@teetsh/app/src/components/Buttons/Button';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { SwitchToggle } from '@teetsh/app/src/components/Form/SwitchToggle';
import { CheckIcon as Check } from '@heroicons/react/24/outline';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

export function ChangePassword() {
  const userPref = useUser();
  const { t } = useTranslation(['userSettings', 'common']);
  const { hasXcharactersOrMore } = useTranslatedValidation();
  const [displayPassword, setDisplayPassword] = useState<boolean>(false);
  const { notifyError, notifySuccess } = useNotification();
  const updateUser = useUpdateUser();
  return (
    <Form<UserProfile>
      validate={values => ({
        password: !values.password
          ? t('common:validation.requiredField')
          : undefined,
      })}
      initialValues={userPref}
      onSubmit={v =>
        updateUser(v)
          .then(() =>
            notifySuccess({
              title: t('userSettings:messages.passwordUpdatedSuccess'),
            }),
          )
          .catch(() => {
            notifyError({ title: t('common:messages.genericError') });
          })
      }
    >
      {({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <div style={{ maxWidth: '15rem' }}>
            <Field
              name="password"
              label={t('userSettings:password.newPassword')}
              type={displayPassword ? 'text' : 'password'}
              validate={hasXcharactersOrMore(4)}
              component={Input}
            />
          </div>
          <div tw="mt-3">
            <SwitchToggle
              checked={displayPassword}
              label={t('userSettings:password.showPassword')}
              onChange={() => setDisplayPassword(!displayPassword)}
            />
          </div>
          <div tw="text-center mt-8">
            <Button
              loading={submitting}
              large
              intent="primary"
              type="submit"
              icon={Check}
            >
              {t('common:buttons.save')}
            </Button>
          </div>
        </form>
      )}
    </Form>
  );
}
